import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/bis-econocom.svg'
import _imports_1 from '@/assets/images/thumb.svg'
import _imports_2 from '@/assets/images/arrow-down.svg'
import _imports_3 from '@/assets/images/dashboard.svg'
import _imports_4 from '@/assets/images/service.svg'


const _hoisted_1 = {
  key: 0,
  class: "navbar navbar-dark sticky-top bg-purple-4 flex-md-nowrap p-0"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  class: "logo navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler position-absolute d-md-none collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#sidebarMenu",
  "aria-controls": "sidebarMenu",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_4 = { class: "navbar-nav" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Geert ")
const _hoisted_7 = {
  key: 0,
  src: _imports_2,
  style: {"transform":"rotate(180deg)"}
}
const _hoisted_8 = {
  key: 1,
  src: _imports_2
}
const _hoisted_9 = {
  key: 0,
  class: "dropdown-content"
}
const _hoisted_10 = { class: "nav-profile" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Geert Groen ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Mijn profiel", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Instellingen", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Mijn support tickets", -1)
const _hoisted_16 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  class: "col-md-3 col-lg-2 d-md-block sidebar collapse",
  id: "sidebarMenu"
}
const _hoisted_19 = { class: "position-sticky sidebar-sticky" }
const _hoisted_20 = { class: "nav flex-column" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Dashboard ")
const _hoisted_24 = { class: "nav-item" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Support ")
const _hoisted_27 = { class: "col-md-9 ms-sm-auto col-lg-10 px-md-4" }
const _hoisted_28 = { class: "container-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "dropbtn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleUserMenu && _ctx.toggleUserMenu(...args)))
            }, [
              _hoisted_5,
              _hoisted_6,
              (_ctx.showUserMenu == true)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.showUserMenu == false)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            (_ctx.showUserMenu)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", null, [
                      _hoisted_12,
                      _createElementVNode("span", null, _toDisplayString(_ctx.$root.user.name), 1)
                    ])
                  ]),
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                  }, "Uitloggen")
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("nav", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("ul", _hoisted_20, [
                  _createElementVNode("li", _hoisted_21, [
                    _createVNode(_component_router_link, {
                      class: "nav-link",
                      to: "/"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22,
                        _hoisted_23
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_24, [
                    _createVNode(_component_router_link, {
                      class: "nav-link active",
                      to: { name: 'support' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_25,
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("main", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_router_view)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}